import { GuestType } from 'src/api/api.generated'
import { TFunction } from 'react-i18next'

export function displayGuestType(t: TFunction<'translation', undefined>, guestType: GuestType): string {
  const key = `commons.guest_type.${guestType.toLowerCase()}`
  return t(key as any)
}

export function displayGuestsCount(t: TFunction<'translation', undefined>, adults: number, children: number, showZero?: boolean): string {
  let result = ''
  if (adults || showZero) {
    result = `${adults}${t('pms.booking.reservation.guest_type.adults')}`
  }
  if ((adults && children) || showZero) {
    result = result + ' + '
  }
  if (children || showZero) {
    result = result + `${children}${t('pms.booking.reservation.guest_type.children')}`
  }
  return result
}
